
export enum Role {
  READER = "READER",
  TRIAGE = "TRIAGE",
  WRITER = "WRITER",
  SUPPORT = "SUPPORT",
  FINANCE = "FINANCE",
  ADMIN = "ADMIN"
}